import React from 'react';
import {
  Show,
  SimpleShowLayout,
  DateField,
  ReferenceField,
  TextField,
  ListButton,
} from 'react-admin';
import CardActions from '@material-ui/core/CardActions';

import FullNameField from '../General/FullNameField';

import { PreviewField } from './PreviewField';

export const JSONField = ({ record, source }) => (
  <div
    style={{
      fontFamily: 'monospace',
      background: '#eee',
      padding: '1em',
    }}
  >
    {JSON.stringify(record[source], null, 2)}
  </div>
);
JSONField.defaultProps = {
  addLabel: true,
};


const Title = ({ record }) => (
  <span>Push Notificaion #{record.id}</span>
);

const cardActionStyle = {
  zIndex: 2,
  display: 'inline-block',
  float: 'right',
};


const Actions = ({ basePath }) => (
  <CardActions style={cardActionStyle}>
    <ListButton basePath={basePath} />
  </CardActions>
);


export default props => (
  <Show
    {...props}
    actions={<Actions />}
    title={<Title />}
  >
    <SimpleShowLayout>
      <PreviewField />
      <DateField source="createdAt" showTime />
      <DateField source="updatedAt" showTime />
      <DateField source="sendStartedAt" showTime />
      <DateField source="sendCompletedAt" showTime />
      <ReferenceField label="Created by" source="createdByUserId" reference="users" linkType={false}>
        <FullNameField />
      </ReferenceField>
      <TextField source="title" />
      <TextField source="body" />
      <ReferenceField
        label="Offering"
        source="custom.offerId"
        reference="offerings"
        allowEmpty
      >
        <TextField source="name" />
      </ReferenceField>
      <JSONField source="custom" />
      <JSONField source="sendResults" />
      <TextField source="error" style={{ fontFamily: 'monospace' }} />
    </SimpleShowLayout>
  </Show>
);



// WEBPACK FOOTER //
// ./src/components/PushNotification/Show.js